// Components
import configureStore from '../reactFeatures/company-users/store/configureStore';
import PageActions from '../reactFeatures/company-users/components/PageActions';
import PageHeader from '../reactFeatures/shared/components/PageHeader';
import CompanyUsersList from '../reactFeatures/company-users/components/CompanyUsersList';

export default () => {
  const rootEl = document.getElementById('react--company-users-list');
  if (rootEl) {
    const CompanyUsersIndex = ({ title, backURL }) => (
      <BrowserRouter>
        <div>
          <PageHeader title={title} backURL={backURL}>
            <PageActions />
          </PageHeader>
          <CompanyUsersList />
        </div>
      </BrowserRouter>
    );

    const initialState = {
      ...JSON.parse(document.getElementById('view-data').value),
      invitations: JSON.parse(document.getElementById('invitations-data').value),
      contacts: JSON.parse(document.getElementById('contacts-data').value),
      companyUsersInEditModeIds: [],
      hasOpenForm: false,
      activeTab: 'active',
      projects: JSON.parse(document.getElementById('project-data').value)
    };
    const store = configureStore(initialState);
    const jsx = (
      <Provider store={store}>
        <CompanyUsersIndex {...store.getState()} />
      </Provider>
    );

    render(jsx, rootEl);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/CompanyUsersIndex.js